import type { NodeData, PathLookupNodeData } from '@ipfabric/utils';

export const isPathLookupNodeData: {
  (nodeData?: NodeData | null): nodeData is PathLookupNodeData;
  (
    nodeData?: Omit<NodeData, 'position'> | null,
  ): nodeData is Omit<PathLookupNodeData, 'position'>;
} = (nodeData?: any | null): nodeData is any =>
  nodeData !== undefined &&
  nodeData !== null &&
  nodeData.graphType === 'pathLookup';
